import React from 'react';
import Slider from 'react-slick';
import ClientItem from './ClientItem';

const clientsIcons = ['oppo.svg', 'amazon_alexa.svg', 'sony.png', 'temi.svg',
  'google.svg', 'medisana.svg', 'facetune.png',
  'kaltura.png', 'elle.svg', 'top10.svg', 'empirecruises.png', '88rising.png', 'universal.png'];

function ClientsSlider() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: true,
    // speed: 2000,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1230,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      }],
  };
  return (
    <div style={{ padding: '20px' }}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Slider {...settings}>
        {clientsIcons.map((client) => <ClientItem key={client} clientName={client.split('.')[0] || client} clientUrl={`../img/clients/${client}`} />)}
      </Slider>
    </div>
  );
}

export default ClientsSlider;
